import { c as _c } from "react/compiler-runtime";
import { ApolloProvider } from "@apollo/client";
import type { Session } from "next-auth";
import { SessionProvider } from "next-auth/react";
import { type AppProps } from "next/app";
import { SnackbarProvider } from "notistack";
import React from "react";
import "symbol-observable";
import { CookieConsentRoot } from "#/features/cookieConsent/ui/CookieConsentRoot";
import { ProjectBrowser } from "#/features/project/ui/ProjectBrowser/ProjectBrowser";
import { ProjectBrowserProvider } from "#/features/project/ui/ProjectBrowser/ProjectBrowserContext";
import { apolloClient } from "#/graphql/apolloClient";
import { type I18nProps } from "#/i18n/getI18nProps";
import { api } from "#/shared/api";
import { EmotionCacheProvider } from "#/shared/emotion/EmotionCacheContext";
// `_document` is server-only; importing fonts here registers @font-face + CSS vars in the client bundle.
import "#/shared/fonts/appFonts";
import { SnackbarCloseButton } from "#/shared/ui/atoms/SnackbarCloseButton";
import { I18nProvider } from "#/shared/ui/providers/I18nProvider";
import { StateThemeProvider } from "#/shared/ui/providers/StateThemeProvider";
import { isSnackbarClosable } from "#/shared/ui/snackbarClosability";
import { ReduxProvider } from "#/store/provider";
import type { SsrDeviceType } from "#/themes";
import "#/styles/globals.css";
import "overlayscrollbars/overlayscrollbars.css";
type MyAppProps = {
  session: Session | null;
  i18n?: I18nProps;
  ssrDeviceType?: SsrDeviceType;
};
const MyApp: React.FC<AppProps<MyAppProps>> = t0 => {
  const $ = _c(16);
  const {
    Component,
    pageProps
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      containerAnchorOriginBottomLeft: "snackbar-mobile-bottom-margin",
      containerAnchorOriginBottomCenter: "snackbar-mobile-bottom-margin",
      containerAnchorOriginBottomRight: "snackbar-mobile-bottom-margin"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== Component || $[2] !== pageProps) {
    t2 = <Component {...pageProps} />;
    $[1] = Component;
    $[2] = pageProps;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <ProjectBrowser />;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t2) {
    t4 = <CookieConsentRoot><ProjectBrowserProvider>{t2}{t3}</ProjectBrowserProvider></CookieConsentRoot>;
    $[5] = t2;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== pageProps.i18n || $[8] !== t4) {
    t5 = <SnackbarProvider maxSnack={4} action={_temp} classes={t1}><I18nProvider i18n={pageProps.i18n}>{t4}</I18nProvider></SnackbarProvider>;
    $[7] = pageProps.i18n;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== pageProps.ssrDeviceType || $[11] !== t5) {
    t6 = <ApolloProvider client={apolloClient}><StateThemeProvider ssrDeviceType={pageProps.ssrDeviceType}>{t5}</StateThemeProvider></ApolloProvider>;
    $[10] = pageProps.ssrDeviceType;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== pageProps.session || $[14] !== t6) {
    t7 = <EmotionCacheProvider><ReduxProvider><SessionProvider session={pageProps.session}>{t6}</SessionProvider></ReduxProvider></EmotionCacheProvider>;
    $[13] = pageProps.session;
    $[14] = t6;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  return t7;
};
export default api.withTRPC(MyApp);
function _temp(snackbarKey) {
  return isSnackbarClosable(snackbarKey) ? <SnackbarCloseButton snackbarKey={snackbarKey} /> : null;
}